import { useLocation } from 'react-router-dom';

export const useLocationParams = () => {
  const { search, pathname } = useLocation();

  const queryParams = new URLSearchParams(search);

  const tabParam = queryParams.get('tab');
  const tabIndex = sessionStorage.getItem('tabIndex');

  const tabName: Record<string, string> = {
    plan: 'Plan',
    'about-you': 'About You',
    checkout: 'Checkout',
  };

  const tab = tabParam ? tabName[tabParam] : null;

  return {
    searchParams: search,
    tab,
    tabIndex,
    pathname,
  };
};
